import React, { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import Select from '@hilbi/web-common/components/e-visits/select';
import TStore from '../../../../../types/store';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useFieldData } from '../reservation-form.utils';
import { actions } from '../../../../../store/ducks/reservation-form-slice';
import { SelectFieldProps } from '../../../../../types/reservation-form';
import { FormField } from '@hilbi/web-common/components/hilbi-form';

type TimeRangeSelectProps = SelectFieldProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const TimeRangeSelect: React.FunctionComponent<TimeRangeSelectProps> = ({
  name,
  timeRangeOptions,
  disabled,
  setTimeRangePickerHidden,
  updateEditedEventPosition,
}) => {
  const { formatMessage } = useIntl();
  const { value, setValue, error } = useFieldData(name);

  const displayedOptions = useMemo(() => {
    return timeRangeOptions.map((option) => {
      if (option.default) {
        return {
          ...option,
          label: `${formatMessage({ id: 'reservation_form_time_custom_value' })}`,
          translated: true,
        };
      } else {
        return option;
      }
    });
  }, [timeRangeOptions]);

  const displayedValue = useMemo(() => {
    if (value.default && !value.translated) {
      return {
        ...value,
        label: `${formatMessage({ id: 'reservation_form_time_custom_value' })}`,
      };
    } else {
      return value;
    }
  }, [value]);

  useEffect(() => {
    setTimeRangePickerHidden(!value.default);
    updateEditedEventPosition({
      from: value.from,
      to: value.to,
    });
  }, [value]);

  return (
    <FormField
      className={'time-range-field'}
      disabled={disabled}
      error={error ? formatMessage({ id: error }) : ''}
    >
      <Select
        isDisabled={disabled}
        name={name}
        onChange={(v: any) => {
          setValue(v || null);
        }}
        options={displayedOptions}
        value={displayedValue}
      />
    </FormField>
  );
};

const mapStateToProps = (state: TStore) => ({
  timeRangeOptions: state.reservationForm.timeRangeOptions,
});

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      setTimeRangePickerHidden: actions.setTimeRangePickerHidden,
      updateEditedEventPosition: actions.updateEditedEventPosition,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(TimeRangeSelect));
